import './Projects.css';
import webpage from '../assets/Webpage.gif'

const Webpage = () => {
    return(
        
        <section class="container grid project-contents">
            <br></br>
            <br></br>
            <div class="project-contents">
                <h3> WEBPAGE DESIGNED WITH REACT </h3>
                <br></br>
                <div>
                    <img src={webpage}/>
                </div>
                <p class="project-caption"> Webpage View </p>
                <div class="project-text"> 
                    Portfolio Webpage of Sun Lee containing software development projects, computation geometry workflows for architectural projects.
                </div>
                <br></br>
            </div>
        </section>
    );
}

export default Webpage;